"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagIwIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagIwIcon = (0, _mobxReact.observer)(_class = (_FlagIwIcon = /*#__PURE__*/function (_React$Component) {
  function FlagIwIcon() {
    _classCallCheck(this, FlagIwIcon);
    return _callSuper(this, FlagIwIcon, arguments);
  }
  _inherits(FlagIwIcon, _React$Component);
  return _createClass(FlagIwIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 100 100",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#FFFFFF",
        x: "0",
        y: "0",
        width: "100",
        height: "100"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(0.000000, 9.000000)",
        fill: "#0035B9"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M67.3,31 L55.8,31 L50,21 L44.2,31 L32.7,31 L38.5,41 L32.7,51 L44.3,51 L50,61 L55.8,51 L67.4,51 L61.6,41 L67.3,31 Z M57.1,41 L53.5,47.2 L46.4,47.2 L42.9,41 L46.5,34.8 L53.6,34.8 L57.1,41 Z M50,28.7 L51.3,31 L48.7,31 L50,28.7 Z M39.3,34.8 L42,34.8 L40.7,37.1 L39.3,34.8 Z M39.3,47.2 L40.6,44.9 L41.9,47.2 L39.3,47.2 Z M50,53.3 L48.7,51 L51.3,51 L50,53.3 Z M60.7,47.2 L58,47.2 L59.3,44.9 L60.7,47.2 Z M58,34.8 L60.6,34.8 L59.3,37.1 L58,34.8 Z",
        id: "Shape"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        x: "0",
        y: "0.5",
        width: "100",
        height: "11.6"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        x: "0",
        y: "69.9",
        width: "100",
        height: "11.6"
      })))));
    }
  }]);
}(_react["default"].Component), _FlagIwIcon.defaultProps = {
  width: '20px'
}, _FlagIwIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagIwIcon);